import toast from 'react-hot-toast';
import getSuccessOptions from '../utils/getSuccessOptions';
import parseMessage from '../utils/parseMessage';

const success = (message, options) =>
  toast.success(parseMessage(message), getSuccessOptions(options));

export default success;
